export default __webpack_public_path__ + "static/media/coop.79ddd306.jpg";